import { ControlType, Property, PropertyType } from "../../../base/types";
import { FC, useEffect, useState } from "react";

import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import clsx from "clsx";
import { toAbsoluteUrl } from "../../../../helpers";
import { useGetProperties } from "../../../base/hooks";

export const Base64ImageComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const tooltip: string | undefined = properties[Property.Tooltip];
    const base64Image: string | undefined = properties[Property.Base64Image];
    const altText: string | undefined = properties[Property.AltText];

    const [base64, setBase64] = useState<string>()

    useEffect(() => {
        if (!base64Image) {
            setBase64(undefined)
            return;
        }

        if (base64Image.startsWith("data:"))
            setBase64(base64Image)
        else
            setBase64(`data:image/png;base64, ${base64Image}`)
    }, [base64Image])

    if (!base64)
        return <div className="h-75px d-flex justify-content-center">
            <img alt={altText} className={clsx(className)}
                style={{ objectFit: "cover", objectPosition: "top", height: "100%" }}
                src={toAbsoluteUrl('/media/svg/general/no-image-placeholder.svg')} title={tooltip} />
        </div>
    return (
        <img alt={altText} className={clsx(className)}
            style={{ objectFit: "cover", objectPosition: "top" }}
            src={base64} title={tooltip} />
    )
}

Registry.addControl({
    id: "bf46b7d8-bda1-440e-a62c-1b857019d033",
    name: "Image (Base64)",
    type: ControlType.Base64Image,
    properties: [
        { id: Property.AltText, name: 'Alternate text', type: PropertyType.String },
        { id: Property.Base64Image, name: 'Base64 Image', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: Base64ImageComponent
})
